import { createFileRoute } from "@tanstack/react-router";

import { ProjectsIndexPanel } from "../../../workspaces/settings/ProjectsIndexPanel";

export const Route = createFileRoute("/_console/settings/projects/")({
  component: ProjectsIndexPanel,
});
